module.exports = __webpack_public_path__ + "img/converse.d2f3e53d.png";